import { showError } from '@/utils'
/**
 * localStorage管理
 */

/** storageへ保存 */
export const setStorage = (key, value) => {
  isAvailable(() => {
    localStorage.setItem(key, value)
  })
}

/** storageから削除 */
export const deleteStorage = key => {
  isAvailable(() => {
    localStorage.removeItem(key)
  })
}

/** storageから取得 */
export const getStorage = key => localStorage.getItem(key)

/** safariプライベートブラウジング時に */
const isAvailable = func => {
  try {
    func()
  } catch (e) {
    showError(e)
  }
}
